module.exports = __webpack_public_path__ + "static/weather-d228f7519af97c382a4876b4a6d700c0.jpg";